export default "__VITE_ASSET__z3q5ilnY__"